import { PlanFormModel } from "../../app/form";

// Request
import { PriceRequest } from "./price.request";
import { SubscriptionPlanFeatureRequest } from "./subscription-plan-feature.request";

export class PlanRequest {
  name: string;
  description: string;
  access_to_analytics: boolean;
  allowed_number_of_branches: number;
  gives_premium_access: boolean;
  trial_period_days: number | null;
  per_booking_fee: number | null;
  contact_only: boolean;
  // Contact-only plans are created without a price (undefined is dropped from JSON).
  price?: PriceRequest;
  subscription_plan_features: SubscriptionPlanFeatureRequest[];

  constructor(planForm: PlanFormModel) {
    this.name = planForm.name;
    this.description = planForm.description;
    this.access_to_analytics = planForm.accessToAnalytics;
    this.gives_premium_access = planForm.givesPremiumAccess;
    this.allowed_number_of_branches = planForm.allowedNumberOfBranches;
    this.trial_period_days = planForm.trialPeriodDays
      ? Number(planForm.trialPeriodDays)
      : null;
    // Dollars -> cents, same as PriceRequest.
    this.per_booking_fee = planForm.perBookingFee
      ? Number(planForm.perBookingFee) * 100
      : null;
    this.contact_only = planForm.contactOnly;
    this.price = planForm.contactOnly
      ? undefined
      : new PriceRequest(planForm.price);
    this.subscription_plan_features = planForm.subscriptionPlanFeatures.map(
      (feature) => new SubscriptionPlanFeatureRequest(feature)
    );
  }
}
